import { useMemo } from 'react';
import { useGameStore } from '../../simulation/store';
import { coordToWorld } from '../../utils/grid';

export function RoadsLayer() {
  const cells = useGameStore((state) => state.world.cells);
  const size = useGameStore((state) => state.world.size);
  const roads = useMemo(() => cells.filter((cell) => cell.road), [cells]);

  return (
    <group>
      {roads.map((cell) => {
        const position = coordToWorld(cell.coord, size);
        const opacity = cell.roadEdge ? 0.36 : 0.78;

        return (
          <group key={`road-${cell.key}`} position={[position.x, 0.023, position.z]}>
            <mesh rotation={[-Math.PI / 2, 0, 0]}>
              <planeGeometry args={[0.9, 0.08]} />
              <meshBasicMaterial color="#d7d1bb" transparent opacity={opacity} />
            </mesh>
            <mesh rotation={[-Math.PI / 2, 0, Math.PI / 2]}>
              <planeGeometry args={[0.9, 0.035]} />
              <meshBasicMaterial color="#f3c66f" transparent opacity={opacity * 0.5} />
            </mesh>
          </group>
        );
      })}
    </group>
  );
}
